import './App.css';
import FoodGallery from './FoodGallery';

function App() {
  return (
    <FoodGallery/>
  );
}

export default App;
